import Axios from "axios";

export class PnService {

    getLista(params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/certificacion-pn/lista-fideicomiso?${queryParams}`).then(res => res.data);
    }

    nuevo(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/trust/certificacion-pn/nuevo`, data).then(res => res.data);
    }

    nuevoFideicomiso(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/trust/certificacion-pn/nuevo-fideicomiso`, data).then(res => res.data);
    }

    editar(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/trust/certificacion-pn/editar`, data).then(res => res.data);
    }

    editarFideicomiso(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/trust/certificacion-pn/editar-fideicomiso`, data).then(res => res.data);
    }

    consultar(id, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/certificacion-pn/consulta/${id}`, { params: opciones }).then(res => res.data);
    }

    consultarFideicomiso(id, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/certificacion-pn/consulta-fideicomiso/${id}`, { params: opciones }).then(res => res.data);
    }

    eliminar(id, opciones = {}) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/trust/certificacion-pn/eliminar/${id}`, { params: opciones }).then(res => res.data);
    }

    eliminarFideicomiso(id, opciones = {}) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/trust/certificacion-pn/eliminar-fideicomiso/${id}`, { params: opciones }).then(res => res.data);
    }

    descargar(id, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/certificacion-pn/reporte/${id}`, 
            { headers: { 'Content-Type': 'application/json', 'Pragma': 'no-cache' }, responseType: 'blob', params: opciones }).then(async res => res.data);
    }
}
